module.exports = __webpack_public_path__ + "img/warning-page-bottom-banner.6fa22f54.svg";